import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import { toast } from 'sonner';
import {
  Plus,
  Edit,
  Trash2,
  Copy,
  DollarSign,
  Package,
  ToggleLeft,
  ToggleRight,
  FileSpreadsheet,
  History,
  Tag,
  Percent,
  Search,
  X
} from 'lucide-react';
import { formatCurrency } from '../utils/formatters';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Componente separado para cada fila de precio de producto
const PriceListItemRow = ({ item, onUpdatePrice, formatCurrency, isGeneralList }) => {
  const [editingPrice, setEditingPrice] = useState(false);
  const [editingDiscount, setEditingDiscount] = useState(false);
  const [editingMinPrice, setEditingMinPrice] = useState(false);
  const [tempPrecio, setTempPrecio] = useState(item.precio_custom || '');
  const [tempDescuento, setTempDescuento] = useState(item.descuento_porcentaje !== null && item.descuento_porcentaje !== undefined ? item.descuento_porcentaje : '');
  const [tempPrecioMinimo, setTempPrecioMinimo] = useState(item.precio_minimo || '');

  return (
    <tr key={item.producto_id} className="border-b hover:bg-slate-50">
      <td className="p-3">
        <div className="font-medium text-slate-800">{item.producto_nombre}</div>
        <div className="text-xs text-slate-500">{item.producto_id}</div>
      </td>
      <td className="p-3 text-slate-600">{item.categoria}</td>
      <td className="p-3 text-right font-medium">{formatCurrency(item.precio_base)}</td>
      {isGeneralList && (
        <td className="p-3">
          {editingPrice ? (
            <Input
              type="number"
              min="0"
              step="0.01"
              value={tempPrecio}
              onChange={(e) => setTempPrecio(e.target.value)}
              onBlur={() => {
                onUpdatePrice(
                  item.producto_id,
                  parseFloat(tempPrecio) || null,
                  item.descuento_porcentaje,
                  item.precio_minimo
                );
                setEditingPrice(false);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onUpdatePrice(
                    item.producto_id,
                    parseFloat(tempPrecio) || null,
                    item.descuento_porcentaje,
                    item.precio_minimo
                  );
                  setEditingPrice(false);
                }
              }}
              autoFocus
              className="h-8 text-center"
            />
          ) : (
            <div
              onClick={() => {
                setTempPrecio(item.precio_custom || '');
                setEditingPrice(true);
              }}
              className="cursor-pointer hover:bg-slate-100 rounded p-1 text-center"
            >
              {item.precio_custom ? (
                <span className="font-semibold text-blue-600">
                  {formatCurrency(item.precio_custom)}
                </span>
              ) : (
                <span className="text-slate-400">-</span>
              )}
            </div>
          )}
        </td>
      )}
      {!isGeneralList && (
        <td className="p-3">
          {editingDiscount ? (
            <Input
              type="number"
              step="0.01"
              value={tempDescuento}
              onChange={(e) => setTempDescuento(e.target.value)}
              onBlur={() => {
                const descValue = tempDescuento === '' ? null : parseFloat(tempDescuento);
                onUpdatePrice(
                  item.producto_id,
                  item.precio_custom,
                  descValue,
                  item.precio_minimo
                );
                setEditingDiscount(false);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const descValue = tempDescuento === '' ? null : parseFloat(tempDescuento);
                  onUpdatePrice(
                    item.producto_id,
                    item.precio_custom,
                    descValue,
                    item.precio_minimo
                  );
                  setEditingDiscount(false);
                }
              }}
              autoFocus
              className="h-8 text-center"
            />
          ) : (
            <div
              onClick={() => {
                setTempDescuento(item.descuento_porcentaje !== null && item.descuento_porcentaje !== undefined ? item.descuento_porcentaje : '');
                setEditingDiscount(true);
              }}
              className="cursor-pointer hover:bg-slate-100 rounded p-1 text-center"
            >
              {item.descuento_porcentaje !== null && item.descuento_porcentaje !== undefined ? (
                <span className={`font-semibold ${item.descuento_porcentaje < 0 ? 'text-red-600' : item.descuento_porcentaje === 0 ? 'text-slate-600' : 'text-emerald-600'}`}>
                  {item.descuento_porcentaje > 0 ? '-' : item.descuento_porcentaje < 0 ? '+' : ''}{Math.abs(item.descuento_porcentaje)}%
                </span>
              ) : (
                <span className="text-slate-400">-</span>
              )}
            </div>
          )}
        </td>
      )}
      {isGeneralList && (
        <td className="p-3">
          {editingMinPrice ? (
            <Input
              type="number"
              min="0"
              step="0.01"
              value={tempPrecioMinimo}
              onChange={(e) => setTempPrecioMinimo(e.target.value)}
              onBlur={() => {
                onUpdatePrice(
                  item.producto_id,
                  item.precio_custom,
                  item.descuento_porcentaje,
                  parseFloat(tempPrecioMinimo) || null
                );
                setEditingMinPrice(false);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onUpdatePrice(
                    item.producto_id,
                    item.precio_custom,
                    item.descuento_porcentaje,
                    parseFloat(tempPrecioMinimo) || null
                  );
                  setEditingMinPrice(false);
                }
              }}
              autoFocus
              className="h-8 text-center"
            />
          ) : (
            <div
              onClick={() => {
                setTempPrecioMinimo(item.precio_minimo || '');
                setEditingMinPrice(true);
              }}
              className="cursor-pointer hover:bg-slate-100 rounded p-1 text-center"
            >
              {item.precio_minimo ? (
                <span className="font-semibold text-orange-600">
                  {formatCurrency(item.precio_minimo)}
                </span>
              ) : (
                <span className="text-slate-400">-</span>
              )}
            </div>
          )}
        </td>
      )}
      <td className="p-3 text-right">
        <span className="font-bold text-green-600">{formatCurrency(item.precio_final)}</span>
      </td>
      <td className="p-3 text-center">
        {(item.tiene_precio_custom || item.tiene_descuento) && (
          <Button
            size="sm"
            variant="ghost"
            onClick={() => onUpdatePrice(item.producto_id, null, null, null)}
            className="h-7 text-red-600 hover:text-red-800 hover:bg-red-50"
          >
            <Trash2 size={14} />
          </Button>
        )}
      </td>
    </tr>
  );
};

const PriceLists = ({ user }) => {
  const [priceLists, setPriceLists] = useState([]);
  const [selectedList, setSelectedList] = useState(null);
  const [products, setProducts] = useState([]);
  const [priceItems, setPriceItems] = useState([]);
  const [categoryDiscounts, setCategoryDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [pricesDialogOpen, setPricesDialogOpen] = useState(false);
  const [categoryDiscountDialogOpen, setCategoryDiscountDialogOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    descuento_global: 0,
  });

  const [categoryDiscountData, setCategoryDiscountData] = useState({
    categoria: '',
    descuento_porcentaje: 0,
  });

  // Obtener listas de precios
  const fetchPriceLists = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/price-lists`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setPriceLists(response.data);
      setLoading(false);
    } catch (error) {
      toast.error('Error al cargar listas de precios');
      setLoading(false);
    }
  };

  // Obtener productos
  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/products`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setProducts(response.data);
    } catch (error) {
      toast.error('Error al cargar productos');
    }
  };

  // Obtener items de precios de una lista específica
  const fetchPriceItems = async (listId) => {
    try {
      const response = await axios.get(`${API_URL}/api/price-lists/${listId}/items`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setPriceItems(response.data);
    } catch (error) {
      toast.error('Error al cargar precios');
    }
  };

  // Obtener descuentos por categoría
  const fetchCategoryDiscounts = async (listId) => {
    try {
      const response = await axios.get(`${API_URL}/api/price-lists/${listId}/category-discounts`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setCategoryDiscounts(response.data);
    } catch (error) {
      toast.error('Error al cargar descuentos por categoría');
    }
  };

  useEffect(() => {
    fetchPriceLists();
    fetchProducts();
  }, []);

  const handleCreateList = async () => {
    try {
      await axios.post(`${API_URL}/api/price-lists`, formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      toast.success('Lista de precios creada exitosamente');
      setDialogOpen(false);
      setFormData({ nombre: '', descripcion: '', descuento_global: 0 });
      fetchPriceLists();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al crear lista');
    }
  };

  const handleUpdateList = async () => {
    try {
      await axios.patch(
        `${API_URL}/api/price-lists/${selectedList.id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      toast.success('Lista actualizada exitosamente');
      setEditDialogOpen(false);
      setSelectedList(null);
      fetchPriceLists();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al actualizar lista');
    }
  };

  const handleToggleActive = async (list) => {
    try {
      await axios.patch(
        `${API_URL}/api/price-lists/${list.id}`,
        { activa: !list.activa },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      toast.success(`Lista ${list.activa ? 'desactivada' : 'activada'}`);
      fetchPriceLists();
    } catch (error) {
      toast.error('Error al cambiar estado');
    }
  };

  const handleDuplicateList = async (list) => {
    const newName = prompt(`Nombre para la copia de "${list.nombre}":`);
    if (!newName) return;

    try {
      await axios.post(
        `${API_URL}/api/price-lists/${list.id}/duplicate?new_name=${encodeURIComponent(newName)}`,
        {},
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      toast.success('Lista duplicada exitosamente');
      fetchPriceLists();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al duplicar lista');
    }
  };

  const handleDeleteList = async (list) => {
    if (list.es_general) {
      toast.error('No se puede eliminar la lista General');
      return;
    }

    if (!window.confirm(`¿Eliminar la lista "${list.nombre}"?`)) return;

    try {
      await axios.delete(`${API_URL}/api/price-lists/${list.id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      toast.success('Lista eliminada');
      fetchPriceLists();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al eliminar lista');
    }
  };

  const openEditDialog = (list) => {
    setSelectedList(list);
    setFormData({
      nombre: list.nombre,
      descripcion: list.descripcion,
      descuento_global: list.descuento_global,
    });
    setEditDialogOpen(true);
  };

  const openPricesDialog = async (list) => {
    setSelectedList(list);
    await fetchPriceItems(list.id);
    await fetchCategoryDiscounts(list.id);
    setPricesDialogOpen(true);
  };

  const handleUpdateProductPrice = async (productId, precio_custom, descuento_porcentaje, precio_minimo) => {
    try {
      const updateData = {
        precio_custom: precio_custom || null,
        descuento_porcentaje: descuento_porcentaje !== null && descuento_porcentaje !== undefined ? descuento_porcentaje : null,
      };
      
      // Solo incluir precio_minimo si es la Lista General
      if (selectedList?.es_general) {
        updateData.precio_minimo = precio_minimo || null;
      }
      
      await axios.put(
        `${API_URL}/api/price-lists/${selectedList.id}/items/${productId}`,
        updateData,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      toast.success('Precio actualizado');
      fetchPriceItems(selectedList.id);
    } catch (error) {
      toast.error('Error al actualizar precio');
    }
  };

  const handleCreateCategoryDiscount = async () => {
    try {
      await axios.post(
        `${API_URL}/api/price-lists/${selectedList.id}/category-discounts`,
        categoryDiscountData,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      toast.success('Descuento por categoría aplicado');
      setCategoryDiscountDialogOpen(false);
      setCategoryDiscountData({ categoria: '', descuento_porcentaje: 0 });
      fetchCategoryDiscounts(selectedList.id);
      fetchPriceItems(selectedList.id);
    } catch (error) {
      toast.error('Error al aplicar descuento');
    }
  };

  const handleDeleteCategoryDiscount = async (categoria) => {
    try {
      await axios.delete(
        `${API_URL}/api/price-lists/${selectedList.id}/category-discounts/${categoria}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      toast.success('Descuento eliminado');
      fetchCategoryDiscounts(selectedList.id);
      fetchPriceItems(selectedList.id);
    } catch (error) {
      toast.error('Error al eliminar descuento');
    }


  const handleExportExcel = async (listId) => {
    try {
      const response = await axios.get(`${API_URL}/api/price-lists/${listId}/export-excel`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      });

      // Crear URL del blob y descargar
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `precios_${new Date().getTime()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success('Precios exportados exitosamente');
    } catch (error) {
      toast.error('Error al exportar precios');
    }
  };

  const handleImportExcel = async (listId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(
        `${API_URL}/api/price-lists/${listId}/import-excel`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const result = response.data;
      let message = `Importación completada: ${result.created} creados, ${result.updated} actualizados`;
      if (result.errors && result.errors.length > 0) {
        message += `\n\nErrores: ${result.errors.slice(0, 5).join('\n')}`;
        if (result.errors.length > 5) {
          message += `\n...y ${result.errors.length - 5} más`;
        }
      }

      toast.success(message);
      await fetchPriceItems(listId);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al importar precios');
    }
  };

  };

  // Obtener categorías únicas
  const categories = [...new Set(products.map((p) => p.categoria))];

  // Filtrar items de precios
  const filteredPriceItems = priceItems.filter((item) => {
    const matchesSearch =
      item.producto_nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.producto_id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || item.categoria === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  if (loading) {
    return <div className="p-6">Cargando...</div>;
  }

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-slate-800">Listas de Precios</h1>
          <p className="text-slate-600 mt-1">
            Gestiona múltiples listas de precios para diferentes tipos de clientes
          </p>
        </div>
        <Button onClick={() => setDialogOpen(true)} className="bg-emerald-500 hover:bg-emerald-600">
          <Plus className="mr-2" size={18} />
          Nueva Lista
        </Button>
      </div>

      {/* Grid de Listas de Precios */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {priceLists.map((list) => (
          <div
            key={list.id}
            className={`border rounded-lg p-4 hover:shadow-md transition-shadow ${
              !list.activa ? 'bg-slate-50 opacity-70' : 'bg-white'
            }`}
          >
            <div className="flex justify-between items-start mb-3">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="text-lg font-semibold text-slate-800">{list.nombre}</h3>
                  {list.es_general && (
                    <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-semibold rounded">
                      Por Defecto
                    </span>
                  )}
                  {!list.activa && (
                    <span className="px-2 py-0.5 bg-red-100 text-red-700 text-xs font-semibold rounded">
                      Inactiva
                    </span>
                  )}
                </div>
                <p className="text-sm text-slate-600 mt-1">{list.descripcion || 'Sin descripción'}</p>
              </div>
            </div>

            {list.descuento_global > 0 && (
              <div className="flex items-center gap-2 text-sm text-emerald-600 font-semibold mb-3">
                <Percent size={16} />
                Descuento global: {list.descuento_global}%
              </div>
            )}

            <div className="flex flex-wrap gap-2">
              <Button
                size="sm"
                variant="outline"
                onClick={() => openPricesDialog(list)}
                className="flex-1"
              >
                <DollarSign size={14} className="mr-1" />
                Precios
              </Button>

              {!list.es_general && (
                <>
                  <Button size="sm" variant="outline" onClick={() => openEditDialog(list)}>
                    <Edit size={14} />
                  </Button>

                  <Button size="sm" variant="outline" onClick={() => handleDuplicateList(list)}>
                    <Copy size={14} />
                  </Button>

                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => handleToggleActive(list)}
                    className={list.activa ? 'text-amber-600' : 'text-emerald-600'}
                  >
                    {list.activa ? <ToggleRight size={14} /> : <ToggleLeft size={14} />}
                  </Button>

                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => handleDeleteList(list)}
                    className="text-red-600 hover:bg-red-50"
                  >
                    <Trash2 size={14} />
                  </Button>
                </>
              )}
            </div>

            <div className="text-xs text-slate-400 mt-3">
              Creada: {new Date(list.created_at).toLocaleDateString('es-DO')}
            </div>
          </div>
        ))}
      </div>

      {/* Diálogo: Crear Lista */}
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Nueva Lista de Precios</DialogTitle>
            <DialogDescription>Crea una nueva lista para gestionar precios personalizados</DialogDescription>
          </DialogHeader>

          <div className="space-y-4">
            <div>
              <Label htmlFor="nombre">Nombre de la Lista*</Label>
              <Input
                id="nombre"
                value={formData.nombre}
                onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                placeholder="Ej: Lista Mayoristas"
              />
            </div>

            <div>
              <Label htmlFor="descripcion">Descripción</Label>
              <Textarea
                id="descripcion"
                value={formData.descripcion}
                onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                rows={3}
                placeholder="Descripción opcional..."
              />
            </div>

            <div>
              <Label htmlFor="descuento_global">Descuento Global (%)</Label>
              <Input
                id="descuento_global"
                type="number"
                min="0"
                max="100"
                step="0.01"
                value={formData.descuento_global}
                onChange={(e) =>
                  setFormData({ ...formData, descuento_global: parseFloat(e.target.value) || 0 })
                }
                placeholder="0"
              />
              <p className="text-xs text-slate-500 mt-1">
                Aplicará a todos los productos que no tengan precio o descuento específico
              </p>
            </div>

            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => setDialogOpen(false)}>
                Cancelar
              </Button>
              <Button
                onClick={handleCreateList}
                disabled={!formData.nombre.trim()}
                className="bg-emerald-500 hover:bg-emerald-600"
              >
                Crear Lista
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Diálogo: Editar Lista */}
      <Dialog open={editDialogOpen} onOpenChange={setEditDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Editar Lista de Precios</DialogTitle>
            <DialogDescription>Actualiza la información de la lista</DialogDescription>
          </DialogHeader>

          <div className="space-y-4">
            <div>
              <Label htmlFor="edit_nombre">Nombre de la Lista*</Label>
              <Input
                id="edit_nombre"
                value={formData.nombre}
                onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                disabled={selectedList?.es_general}
              />
            </div>

            <div>
              <Label htmlFor="edit_descripcion">Descripción</Label>
              <Textarea
                id="edit_descripcion"
                value={formData.descripcion}
                onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                rows={3}
              />
            </div>

            <div>
              <Label htmlFor="edit_descuento_global">Descuento Global (%)</Label>
              <Input
                id="edit_descuento_global"
                type="number"
                min="0"
                max="100"
                step="0.01"
                value={formData.descuento_global}
                onChange={(e) =>
                  setFormData({ ...formData, descuento_global: parseFloat(e.target.value) || 0 })
                }
              />
            </div>

            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => setEditDialogOpen(false)}>
                Cancelar
              </Button>
              <Button onClick={handleUpdateList} className="bg-blue-500 hover:bg-blue-600">
                Guardar Cambios
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Diálogo: Gestión de Precios por Producto */}
      <Dialog open={pricesDialogOpen} onOpenChange={setPricesDialogOpen}>
        <DialogContent className="max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle>
              Precios - {selectedList?.nombre}
              {selectedList?.descuento_global > 0 && (
                <span className="ml-3 text-sm font-normal text-emerald-600">
                  (Descuento global: {selectedList.descuento_global}%)
                </span>
              )}
            </DialogTitle>
            <DialogDescription>
              Configura precios personalizados o descuentos por producto
            </DialogDescription>
          </DialogHeader>

          <div className="flex-1 overflow-y-auto">
            {/* Filtros y Búsqueda */}
            <div className="flex gap-3 mb-4 sticky top-0 bg-white z-10 pb-3 border-b">
              <div className="flex-1 relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} />
                <Input
                  placeholder="Buscar producto..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>

              <Select value={selectedCategory} onValueChange={setSelectedCategory}>
                <SelectTrigger className="w-64">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Todas las categorías</SelectItem>
                  {categories.map((cat) => (
                    <SelectItem key={cat} value={cat}>
                      {cat}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>

              <Button
                size="sm"
                variant="outline"
                onClick={() => setCategoryDiscountDialogOpen(true)}
                className="whitespace-nowrap"
              >
                <Tag size={16} className="mr-2" />
                Descuento por Categoría
              </Button>

              <Button
                size="sm"
                variant="outline"
                onClick={() => handleExportExcel(selectedList.id)}
                className="whitespace-nowrap bg-emerald-50 hover:bg-emerald-100"
              >
                <FileSpreadsheet size={16} className="mr-2" />
                Exportar Excel
              </Button>

              <label htmlFor="import-excel" className="cursor-pointer">
                <Button
                  size="sm"
                  variant="outline"
                  className="whitespace-nowrap bg-blue-50 hover:bg-blue-100"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('import-excel').click();
                  }}
                >
                  <FileSpreadsheet size={16} className="mr-2" />
                  Importar Excel
                </Button>
              </label>
              <input
                id="import-excel"
                type="file"
                accept=".xlsx,.xls"
                className="hidden"
                onChange={(e) => {
                  if (e.target.files[0]) {
                    handleImportExcel(selectedList.id, e.target.files[0]);
                    e.target.value = '';
                  }
                }}
              />
            </div>

            {/* Descuentos por Categoría Activos */}
            {categoryDiscounts.length > 0 && (
              <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                <h4 className="font-semibold text-sm text-amber-900 mb-2">Descuentos por Categoría Activos:</h4>
                <div className="flex flex-wrap gap-2">
                  {categoryDiscounts.map((discount) => (
                    <div
                      key={discount.categoria}
                      className="flex items-center gap-2 bg-white px-3 py-1 rounded border border-amber-300"
                    >
                      <Tag size={14} className="text-amber-600" />
                      <span className="text-sm font-medium">{discount.categoria}</span>
                      <span className="text-sm text-emerald-600 font-semibold">
                        -{discount.descuento_porcentaje}%
                      </span>
                      <button
                        onClick={() => handleDeleteCategoryDiscount(discount.categoria)}
                        className="ml-2 text-red-600 hover:text-red-800"
                      >
                        <X size={14} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Tabla de Productos */}
            <div className="border rounded-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-slate-100 sticky top-0">
                  <tr>
                    <th className="text-left p-3 font-semibold">Producto</th>
                    <th className="text-left p-3 font-semibold">Categoría</th>
                    <th className="text-right p-3 font-semibold">Precio Base</th>
                    {selectedList?.es_general && (
                      <th className="text-center p-3 font-semibold w-32">Precio Custom</th>
                    )}
                    {!selectedList?.es_general && (
                      <th className="text-center p-3 font-semibold w-32">Desc. %</th>
                    )}
                    {selectedList?.es_general && (
                      <th className="text-center p-3 font-semibold w-32">Precio Mínimo</th>
                    )}
                    <th className="text-right p-3 font-semibold">Precio Final</th>
                    <th className="text-center p-3 font-semibold w-24">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPriceItems.map((item) => (
                    <PriceListItemRow
                      key={item.producto_id}
                      item={item}
                      onUpdatePrice={handleUpdateProductPrice}
                      formatCurrency={formatCurrency}
                      isGeneralList={selectedList?.es_general}
                    />
                  ))}
                </tbody>
              </table>
            </div>

            {filteredPriceItems.length === 0 && (
              <div className="text-center py-8 text-slate-500">No se encontraron productos</div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Diálogo: Agregar Descuento por Categoría */}
      <Dialog open={categoryDiscountDialogOpen} onOpenChange={setCategoryDiscountDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Aplicar Descuento por Categoría</DialogTitle>
            <DialogDescription>
              El descuento se aplicará a todos los productos de la categoría seleccionada
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4">
            <div>
              <Label htmlFor="categoria">Categoría*</Label>
              <Select
                value={categoryDiscountData.categoria}
                onValueChange={(value) => setCategoryDiscountData({ ...categoryDiscountData, categoria: value })}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Selecciona una categoría" />
                </SelectTrigger>
                <SelectContent>
                  {categories.map((cat) => (
                    <SelectItem key={cat} value={cat}>
                      {cat}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label htmlFor="descuento_categoria">Descuento (%)*</Label>
              <Input
                id="descuento_categoria"
                type="number"
                step="0.01"
                value={categoryDiscountData.descuento_porcentaje}
                onChange={(e) =>
                  setCategoryDiscountData({
                    ...categoryDiscountData,
                    descuento_porcentaje: parseFloat(e.target.value) || 0,
                  })
                }
                placeholder="0 (positivo=descuento, negativo=sobrecargo)"
              />
            </div>

            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => setCategoryDiscountDialogOpen(false)}>
                Cancelar
              </Button>
              <Button
                onClick={handleCreateCategoryDiscount}
                disabled={!categoryDiscountData.categoria}
                className="bg-emerald-500 hover:bg-emerald-600"
              >
                Aplicar Descuento
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PriceLists;
